import type { FaireProductEntity } from "../../entity_types/product";

export const p_ht9w5def3q: FaireProductEntity = {
  token: "p_ht9w5def3q",
  type: "product",
  name: "Color Block Girlfriend Socks (Wholesale)",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/8a8c182fa6b18e45675305c747e774c6ff342f5fac54273e0f1a917e43c6d255.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8d58ec0fb6ec007953ed5005016a707ea70316d8545ce6b21f543adbc43ab324.jpeg",
    "https://cdn.faire.com/fastly/0318ef297e6a27f7bce87e95d573ac67eb8dd5ac17099a38e40c7c5b317601a6.jpeg",
    "https://cdn.faire.com/fastly/323f21e5afb1c7ac911f8d325694b76adb03d2863b31b0f521b8e19bbabe7248.jpeg",
    "https://cdn.faire.com/fastly/e7ef89556643a82fbee1e5db38f1c55a385fd0d48029a4fb813bd4814fb2d074.jpeg",
    "https://cdn.faire.com/fastly/bca40d03d280fbd236f95469adc979f8ca9b0a2d4c660b8ebb834daeda61f301.jpeg",
    "https://cdn.faire.com/fastly/e72da3b7d5b33bc9147cb9689c7ac0449cfb507182d5926efc9059253070feba.jpeg",
    "https://cdn.faire.com/fastly/7393db7741fe43f2549f6e0bf276f32353f386c3e2388384b2435844f026688c.jpeg",
    "https://cdn.faire.com/fastly/fb29c9842a6a89111ceeb6dd2c636e94ea60ee3282e7808ac2939dc3ecba2277.jpeg",
    "https://cdn.faire.com/fastly/deadc34d229e158d77d2905f7a591b0ec68f1b375e6d393ea9ca52cccd726c50.jpeg",
    "https://cdn.faire.com/fastly/268c2e4c86109602bdb7fe9b14cd0a93dde1f8d2b8a376b50110420cbc0dd65f.jpeg",
    "https://cdn.faire.com/fastly/f08417c5fdc6b4cda1dc40b3ed606275441c66e4a19cb0fa995fb1911624662b.jpeg",
    "https://cdn.faire.com/fastly/a1de83a4fcf4cc06527df11d5fe647aba36d7cde5e8b3ab5452441061514bb3d.jpeg",
    "https://cdn.faire.com/fastly/ea914d98f9a143b13fe06c4a5f789fb8b620fdf6dfd1657b2a6976c03c12eb84.jpeg",
    "https://cdn.faire.com/fastly/8e0921a7b0a8ed9d53865eed69ddf3722fb8b6c85898b8fc7de9031db22d181c.jpeg",
    "https://cdn.faire.com/fastly/6f11ee6883254104b5741feb04306339eb2794988fc13874f5b34915561b68b1.jpeg",
    "https://cdn.faire.com/fastly/ce6c4517c8be6e948e9bf9ca4186fb11f730273f56cccf481e0a2e9e01ca0b1b.jpeg",
    "https://cdn.faire.com/fastly/560fd52c6d82bb096419f031ec4761ca97eba2499a472fd2f7de51fa8b26fef1.jpeg",
    "https://cdn.faire.com/fastly/48b4759beb1315dfb06b6cacc284bf3816122b06a069307ea8624b74b81dfac0.jpeg",
    "https://cdn.faire.com/fastly/ad9aa3c921b23160744db34e72df682917c99c70199957b5d300136bd79f5684.jpeg",
    "https://cdn.faire.com/fastly/dc5db3135e1a829eb06f22d963b0bbfd35911850194d4b3843b9ebf4e78e49f8.jpeg",
    "https://cdn.faire.com/fastly/4bd7d2bffa4bae6553da403a668355ab26e5aaed82be730f17d21b67299a1ff9.jpeg",
    "https://cdn.faire.com/fastly/e874805d5b34f362c4daf09a83145f0500faf0f0cec0c358d74440b82a1cbe4f.jpeg",
    "https://cdn.faire.com/fastly/9ff8985435f19358bbc0c4a8e7e5b105bf0475b56aefc4f909a0df69d0089371.jpeg",
  ],
  priceDollars: 6,
  description:
    "𝐖𝐡𝐲 𝐖𝐞 𝐌𝐚𝐝𝐞 𝐓𝐡𝐢𝐬?\n\nThe perfect novelty accessory that'll accompany you wherever you go. These socks maintain the beloved style and fit of our best-selling Girlfriend socks, but with a playful twist. Featuring fun, color-blocking along the top edge of the ankle and contrasting toes for a youthful flair. Show off the cheeky design by pairing these socks with open-toe sandals or matching them with your favorite sneakers for a timeless look.\n\nMade in South Korea\n\n𝐂𝐨𝐧𝐭𝐞𝐧𝐭𝐬:\n\n85 Cotton 13 Polyester 2 Spdx\n\n𝐒𝐢𝐳𝐢𝐧𝐠:\n\nOne size fits most (US women's size 6-10)\n\n𝐂𝐚𝐫𝐞 𝐈𝐧𝐬𝐭𝐫𝐮𝐜𝐭𝐢𝐨𝐧𝐬:\n\n• Machine wash cold\n• Tumble dry low\n• Do not iron\n• Do not bleach\n\nOrder in units of 6 (6,12,18,24 etc)\n\nMSRP: $14 USD",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:51:58.589Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
